import classNames from "classnames";
import React, { memo } from "react";
import TicketsTableHeader from "./TicketsTableHeader";
import Styles from "./Tickets.module.scss";
import { Ticket } from "./TicketsV3";
import EmptyTickets from "./EmptyTickets";
import TicketRow from "./TicketRow";

interface TicketsTableProps {
    tickets: Ticket[]
    openTicket: (ticketId: number | string) => void
    createTicketRequest: () => void
}

function TicketsTable({ tickets, openTicket, createTicketRequest }: TicketsTableProps) {
    if (tickets.isEmpty) {
        return <EmptyTickets createTicketRequest={createTicketRequest} />;
    }

    return (
        <div className={classNames(Styles["column-group"], Styles["column-group-compact"])}>
            <div className="column-cards column-expanded">
                <table className="cards-table">
                    <TicketsTableHeader />
                    <tbody>
                        {
                            tickets.map(ticket => (
                                <TicketRow
                                    key={ticket.id}
                                    ticket={ticket}
                                    openTicket={openTicket}
                                />
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default memo(TicketsTable);
